// extracted by mini-css-extract-plugin
export default {"input":"styles_input__xj6uk","input__main":"styles_input__main__wYgZh","error":"styles_error__Goe0c","borderError":"styles_borderError__DWXb9"};